import type { ReactNode } from 'react';

interface SidebarProgressRingProps {
  completed: number;
  total: number;
  children: ReactNode;
}

export default function SidebarProgressRing({ completed, total, children }: SidebarProgressRingProps) {
  const size = 40;
  const stroke = 2.5;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const ratio = total > 0 ? Math.min(1, completed / total) : 0;
  const done = ratio >= 1;
  const center = size / 2;

  return (
    <span className="relative grid h-10 w-10 place-items-center" aria-hidden="true">
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="absolute inset-0 -rotate-90"
        aria-hidden="true"
      >
        <circle cx={center} cy={center} r={radius} fill="none" strokeWidth={stroke} className="stroke-gray-200" />
        {ratio > 0 ? (
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference * (1 - ratio)}
            className={done ? 'stroke-emerald-600 dark:stroke-emerald-400 transition-[stroke-dashoffset] duration-300' : 'stroke-red-700 dark:stroke-red-400 transition-[stroke-dashoffset] duration-300'}
          />
        ) : null}
      </svg>
      {children}
    </span>
  );
}
